import dayjs from "dayjs"
import quarterOfYear from "dayjs/plugin/quarterOfYear"

import { langMapISO } from "../../../Utils/utils"

dayjs.extend(quarterOfYear)

const dateFormat = "MMM D, YYYY"
const isoFormat = "YYYY-MM-DD"

export const RANGE_PRESETS = [
  { id: "today", label: "Today", range: () => [dayjs(), dayjs()] },
  {
    id: "last_7_days",
    label: "Last 7 days",
    range: () => [dayjs().subtract(6, "day"), dayjs()]
  },
  {
    id: "last_4_weeks",
    label: "Last 4 weeks",
    range: () => [dayjs().subtract(27, "day"), dayjs()]
  },
  {
    id: "last_6_months",
    label: "Last 6 months",
    range: () => [dayjs().subtract(6, "month"), dayjs()]
  },
  {
    id: "last_12_months",
    label: "Last 12 months",
    range: () => [dayjs().subtract(12, "month"), dayjs()]
  },
  {
    id: "month_to_date",
    label: "Month to date",
    range: () => [dayjs().startOf("month"), dayjs()]
  },
  {
    id: "quarter_to_date",
    label: "Quarter to date",
    range: () => [dayjs().startOf("quarter"), dayjs()]
  },
  {
    id: "year_to_date",
    label: "Year to date",
    range: () => [dayjs().startOf("year"), dayjs()]
  },
  {
    id: "all",
    label: "All time",
    value: "all",
    range: () => [dayjs("2020-01-01"), dayjs()]
  }
]

export const findPresetLabel = ({ min, max, presetId }) => {
  if (presetId) {
    const byId = RANGE_PRESETS.find((p) => p.id === presetId)
    if (byId) return byId.label
  }
  if (!min || !max) {
    return RANGE_PRESETS.find((p) => p.id === "all")?.label ?? null
  }
  const from = dayjs(min).format(isoFormat)
  const to = dayjs(max).format(isoFormat)
  const match = RANGE_PRESETS.find((p) => {
    const [presetFrom, presetTo] = p.range()
    return presetFrom.format(isoFormat) === from && presetTo.format(isoFormat) === to
  })
  return match ? match.label : null
}

export const formatRangeLabel = (min, max, lang) =>
  `${dayjs(min).locale(langMapISO[lang]).format(dateFormat)} - ${dayjs(max)
    .locale(langMapISO[lang])
    .format(dateFormat)}`

export const getPeriodLabel = ({ range, presetId, lang, t }) => {
  const [min = null, max = null] = range || []
  const preset = findPresetLabel({ min, max, presetId })
  if (preset) return t(preset)
  return formatRangeLabel(min, max, lang)
}
